/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".close-img[_ngcontent-%COMP%]{width:38px;height:39px;cursor:pointer;top:-15px;position:relative;right:-12px}.dialog-title[_ngcontent-%COMP%]{display:flex;justify-content:flex-end;padding:0 10px}"];
export { styles as styles };
